var lineButton = function lineButton() {
  document.addEventListener('mouseover', function (e) {
    var button = e.target.closest('.c-lineButton');
    if (button) button.classList.add('is-hovered');
  });
};
export default lineButton;